import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { sendStatsToKibana } from '../analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../analytics/kibana/constants';
import { setQualityLastNWildix, setQualityVideoResWildix, toggleControlVisibility } from './actions';
import { QUALITY_EVENTS_WILDIX } from './constant';
/**
 * Listens when the conference state available.
 */
StateListenerRegistry.register(state => state['features/base/conference'].conference, 
/* listener */ (conference, { dispatch }) => {
    if (!conference) {
        return;
    }
    conference.on(QUALITY_EVENTS_WILDIX.LAST_N, (value) => {
        dispatch(setQualityLastNWildix(value));
        dispatch(sendStatsToKibana([{
                qualityControl: {
                    [QUALITY_EVENTS_WILDIX.LAST_N]: value
                }
            }], KIBANA_MESSAGES.QualityControlOverride));
    });
    conference.on(QUALITY_EVENTS_WILDIX.VIDEO_RESOLUTION, (value) => {
        dispatch(setQualityVideoResWildix(value));
        dispatch(sendStatsToKibana([{
                qualityControl: {
                    [QUALITY_EVENTS_WILDIX.VIDEO_RESOLUTION]: value
                }
            }], KIBANA_MESSAGES.QualityControlOverride));
    });
    conference.on(QUALITY_EVENTS_WILDIX.VIDEO_CODEC, (value) => {
        dispatch(sendStatsToKibana([{
                qualityControl: {
                    [QUALITY_EVENTS_WILDIX.VIDEO_CODEC]: value
                }
            }], KIBANA_MESSAGES.QualityControlOverride));
    });
});
StateListenerRegistry.register((state) => state['wildix/qualityControl'].qualityLastN, 
/* listener */ (qualityLastN, { dispatch }, prevValue) => {
    if (qualityLastN && typeof prevValue !== 'undefined') {
        dispatch(toggleControlVisibility(true));
    }
});
StateListenerRegistry.register((state) => state['wildix/qualityControl'].qualityVideoResolution, 
/* listener */ (qualityVideoResolution, { dispatch }, prevValue) => {
    if (qualityVideoResolution && typeof prevValue !== 'undefined') {
        dispatch(toggleControlVisibility(true));
    }
});
